<template>
  <div class="ott-platform-slider-area">
    <Swiper
      :slidesPerView="1"
      :loop="true"
      :effect="'fade'"
      :speed="1000"
      :autoHeight="true"
      :autoplay="{
        delay: 4000,
        disableOnInteraction: false,
      }"
      :navigation="{
        nextEl: '.button-next',
        prevEl: '.button-prev',
      }"
      :modules="modules"
      class="ott-platform-slider"
    >
      <SwiperSlide v-for="(slide, index) in slides" :key="index">
        <div
          class="ott-platform-slider-item"
          :style="{ backgroundImage: `url(${slide.bgImage})` }"
        >
          <div class="container mw-1685">
            <div class="ott-platform-slider-content" style="text-align: right; direction: rtl;">
              
              <ul class="meta" style="display: flex; gap: 10px; padding: 0; list-style: none; flex-wrap: wrap;">
                <li v-for="(genre, i) in slide.genres" :key="i" style="white-space: nowrap;">
                  <RouterLink to="/channel-list">{{ genre }}</RouterLink>
                </li>
              </ul>

              <h1 style="line-height: 1.3; font-size: 2.8rem; max-width: 100%;">{{ slide.title }}</h1>
              
              <div class="rating-and-clock" style="display: flex; align-items: center; gap: 15px;">
                <ul class="rating" style="display: flex; padding: 0; list-style: none;">
                  <li v-for="n in 5" :key="n">
                    <i class="ri-star-fill"></i>
                  </li>
                  <li>
                    <span>{{ slide.rating }}</span>
                  </li>
                </ul>
                <div class="clock" style="display: flex; align-items: center; gap: 5px;">
                  <img
                    src="@/assets/images/ott-platform/clock.svg"
                    alt="clock"
                  />
                  <span>{{ slide.duration }}</span>
                </div>
              </div>
              <div class="inner-bottom-content">
                <h5>لمحة عن الخدمة</h5>
                <p>
                  {{ slide.plot }}
                  <RouterLink to="/services-details">اقرأ المزيد</RouterLink>
                </p>
                <ul class="btn-list" style="display: flex; gap: 15px; padding: 0; list-style: none;">
                  <li>
                    <!-- رابط مباشر بدون تعقيد الرسائل -->
                    <a href="https://wa.me/447429916178" target="_blank" class="btn">
                      <span class="border-style">اشترك الآن</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://wa.me/447429916178" target="_blank" class="btn">
                      <span class="border-style">تجربة مجانية</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>

      <ul class="ott-platform-slider-button" style="display: flex; gap: 10px; list-style: none;">
        <li>
          <div class="button-next">
            <span>التالي</span>
          </div>
        </li>
        <li>
          <div class="button-prev">
            <span>السابق</span>
          </div>
        </li>
      </ul>
    </Swiper>

    <WatchTeaserTrailer />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation, EffectFade } from "swiper/modules";

import WatchTeaserTrailer from "./WatchTeaserTrailer.vue";

export default defineComponent({
  name: "MainBanner",
  components: {
    Swiper,
    SwiperSlide,
    WatchTeaserTrailer,
  },
  setup() {
    /* eslint-disable @typescript-eslint/no-var-requires */
    const slides = ref([
      {
        bgImage: require("@/assets/images/ott-platform/slider-bg1.jpg"),
        title: "أفضل اشتراك قنوات عربية وعالمية IPTV",
        genres: ["قنوات عربية", "بث مباشر 4K", "ثبات بدون تقطيع"],
        rating: "5.0",
        duration: "تحديث يومي",
        plot: "استمتع بمشاهدة كافة القنوات العربية والعالمية المفضلة لديك مع سيرفر loay iptv. نوفر لك بثاً مباشراً عالي الجودة يضم أضخم باقات الأفلام، المسلسلات، والبرامج التلفزيونية الحصرية وبأعلى ثبات ممكن.",
      },
      {
        bgImage: require("@/assets/images/ott-platform/slider-bg2.jpg"),
        title: "شاهد جميع المباريات والبطولات العالمية حصرياً",
        genres: ["باقات رياضية", "مكتبة أفلام VOD", "دعم فني 24/7"],
        rating: "4.9",
        duration: "سيرفرات فائقة السرعة",
        plot: "لا تفوت أي مباراة بعد الآن! مع loay iptv، تابع أقوى الدوريات والبطولات الرياضية العالمية بجودة فائقة وبدون أي تأخير في البث. مكتبة متجددة من أحدث الأفلام والمسلسلات بانتظارك.",
      },
    ]);
    /* eslint-enable @typescript-eslint/no-var-requires */

    return {
      modules: [Autoplay, Navigation, EffectFade],
      slides,
    };
  },
});
</script>